import * as React from "react";
const SvgEnhancedBadge = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 .25c.225 0 .438.1.58.275.88 1.073 2.148 2.149 3.535 3.007 1.393.861 2.85 1.47 4.098 1.662.794.123 1.537.787 1.537 1.72a18.864 18.864 0 0 1-6.467 14.219l-2.79 2.432a.75.75 0 0 1-.986 0l-2.79-2.432A18.864 18.864 0 0 1 2.25 6.914c0-.934.745-1.6 1.545-1.715 1.33-.193 2.81-.833 4.192-1.71C9.365 2.614 10.59 1.536 11.42.525A.75.75 0 0 1 12 .25ZM8.79 4.755C7.302 5.701 5.62 6.45 4.01 6.683a.351.351 0 0 0-.201.101.186.186 0 0 0-.059.13c0 5.018 2.17 9.79 5.953 13.088L12 22.005l2.297-2.003A17.364 17.364 0 0 0 20.25 6.914a.19.19 0 0 0-.06-.132.364.364 0 0 0-.206-.105c-1.51-.233-3.16-.943-4.658-1.87-1.23-.76-2.394-1.69-3.326-2.674-.882.933-2 1.854-3.21 2.622ZM12 6.25a.75.75 0 0 1 .75.75v3.493h3.492a.75.75 0 0 1 0 1.5H12.75v3.492a.75.75 0 0 1-1.5 0v-3.492H7.757a.75.75 0 1 1 0-1.5h3.493V7a.75.75 0 0 1 .75-.75Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgEnhancedBadge;
